import { render, staticRenderFns } from "./Settings1.vue?vue&type=template&id=22f81a5b&"
import script from "./Settings1.vue?vue&type=script&lang=js&"
export * from "./Settings1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports